import React from 'react';
import Spinner from '../../../components/common/spinner';
import css from '../index.module.css';

interface Props {
  name?: string;
}

export default function DashboardLoading({
  name = 'dashboard-loading',
}: Props) {
  return (
    <div className={css['loading-container']} data-name={name}>
      <Spinner visible size={'lg'} />
    </div>
  );
}
